import React from 'react';
import { SectionShell } from './SectionShell';
import { phases } from '../data/caseStudy';
export function RoleEvolution() {
  return <SectionShell number="02" title="My role evolution" tone="dark" eyebrow="Two distinct phases with two distinct team shapes. The distinction matters: the team of 8 and the pair of direct reports were different jobs, not one averaged headline number." data-id="element-106" data-mp="12u3oitp1d5ci">
      <div className="grid grid-cols-2 gap-10" data-id="element-107" data-mp="f7dn9ukihesy">
        {phases.map(phase => <article key={phase.tag} className="flex flex-col border border-white/15 bg-ink-800 p-10" data-id="element-108" data-mp="k4dwgecnqxoa">
            <div className="h-[3px] w-16 accent-rule" aria-hidden="true" data-id="element-109" data-mp="o6io57jjpk8a" />
            <p className="mt-7 font-display text-[11px] font-semibold uppercase tracking-[0.24em] text-accent-cyan" data-id="element-110" data-mp="sx8rygcbpf0v">
              {phase.tag}
            </p>
            <h3 className="mt-4 font-display text-3xl font-semibold tracking-tightest text-white" data-id="element-111" data-mp="3skqitbjd7730">
              {phase.title}
            </h3>
            <p className="mt-3 text-sm text-white/55" data-id="element-112" data-mp="kb9746lcs1j3">{phase.split}</p>

            <div className="mt-9 border-y border-white/12 py-8" data-id="element-113" data-mp="kckbo8mmhdb9">
              <p className="font-display text-[56px] font-bold leading-none tracking-tightest text-white" data-id="element-114" data-mp="fc6czh6wvfpw">
                {phase.headline}
              </p>
              <p className="mt-3 text-sm leading-snug text-white/60" data-id="element-115" data-mp="5m4quuy4c7dm">{phase.headlineLabel}</p>
            </div>

            <ul className="mt-8 space-y-5" data-id="element-116" data-mp="n0fbxnq1xk4">
              {phase.points.map(point => <li key={point.slice(0, 24)} className="flex gap-4 text-[15px] leading-relaxed text-white/80" data-id="element-117" data-mp="3sq1b0cj0sigb">
                  <span className="mt-[9px] h-[5px] w-[5px] shrink-0 bg-accent-purple" aria-hidden="true" data-id="element-118" data-mp="3nqoh57tqeb48" />
                  <span data-id="element-119" data-mp="3ites3ta981gx">{point}</span>
                </li>)}
            </ul>
          </article>)}
      </div>
    </SectionShell>;
}